import ButtonMain from './Button';
import ButtonGroup from './ButtonGroup';
const ButtonTemp = ButtonMain;
ButtonTemp.Group = ButtonGroup; // To add typings

const Button = ButtonTemp;
export { Button };
//# sourceMappingURL=index.js.map